import { SbbDialogElement } from "@sbb-esta/lyne-elements/dialog.js";
import { SbbDialog, SbbDialogActions, SbbDialogContent, SbbDialogTitle } from "@sbb-esta/lyne-react/dialog";
import React, { PropsWithChildren, ReactNode, useEffect, useRef } from "react";

export interface LyneDialogProps extends PropsWithChildren {
  id?: string;
  backdrop?: "translucent" | "opaque";
  isOpen: boolean;
  title: ReactNode | undefined;
  content: ReactNode | undefined;
  actions: ReactNode | undefined;
}

export const LyneDialog: React.FC<LyneDialogProps> = ({
  id,
  isOpen,
  backdrop = "translucent",
  title,
  content,
  actions: buttons,
}) => {
  const ref = useRef<SbbDialogElement | null>(null);

  useEffect(() => {
    const rc = ref.current;
    if (!rc) return;

    const currentIsOpen = rc.isOpen;
    if (currentIsOpen === isOpen) {
      return;
    }
    if (isOpen) {
      rc.open();
    } else {
      rc.close();
    }
  }, [isOpen, ref]);

  return (
    <SbbDialog backdrop={backdrop} ref={ref} id={id}>
      <SbbDialogTitle>{title}</SbbDialogTitle>
      <SbbDialogContent>{content}</SbbDialogContent>
      <SbbDialogActions>{buttons}</SbbDialogActions>
    </SbbDialog>
  );
};
